import React from 'react'
import actions from 'redux/actions'
import { useConnect } from 'sb-redux-hook'
import { useMemo, useMedia, useEffect, useCallback } from 'sb-hooks'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import ProductsCarousel from './ProductsCarousel/ProductsCarousel'

import messages from './messages'


const placement = 'thank you page'


const ProductsSection = ({ redirectLink }) => {
  const { isMobile } = useMedia()

  const { carouselProducts, selectedProducts } = useConnect({
    carouselProducts: 'view.thankYouPage.carouselProducts',
    selectedProducts: (state) => {
      const {
        models: { queue: { items } },
      } = state

      return items.reduce((productIds, { products }) => {
        const ids = products
          .map(({ id }) => id)
          .filter((id) => id)

        return productIds.concat(ids)
      }, [])
    },
  })

  const hasCarouselProducts = useMemo(() => (
    Object.keys(carouselProducts).some((productType) => (
      carouselProducts[productType].length
    ))
  ), [ carouselProducts ])

  useEffect(() => {
    if (!hasCarouselProducts) {
      actions.view.thankYouPage.fetchCarouselProducts()
    }
  }, [])

  const handleItemAdd = useCallback((product) => {
    actions.models.queue.addItem(product, { placement })
  }, [])

  const handleItemRemove = useCallback(({ name, brand, ...product }) => {
    actions.models.queue.removeItem({
      ...product,
      page: 'thank you',
      metadata: {
        placement,
        brand,
        name,
      },
    })
  }, [])

  return Boolean(hasCarouselProducts) && (
    <WidthContainer>
      <Box pt="36" pb={isMobile ? '36' : '60'}>
        {
          isMobile && (
            <Box pb="24">
              <Text
                message={messages.title}
                size="18-24"
                semibold
              />
            </Box>
          )
        }
        <ProductsCarousel
          items={carouselProducts}
          selectedItems={selectedProducts}
          handleItemAdd={handleItemAdd}
          handleItemRemove={handleItemRemove}
        />
        <Box pt="24">
          <Button
            title={isMobile ? messages.mobileButtonTitle : messages.buttonTitle}
            to={redirectLink}
            size="md"
            color="brand"
            rightIcon="rightArrowSmall"
            fullWidthOnMobile
          />
        </Box>
      </Box>
    </WidthContainer>
  )
}


export default ProductsSection
